<template>
  <div class="answer" v-if="question != null && question != undefined">
    <template v-if="question.type == 15 && question.options.find(x => x.id == question.answer)">
      <span>
        {{ question.options.find(x => x.id == question.answer).title }}
      </span>
      <span class="price" v-if="question.options.find(x => x.id == question.answer).price > 0"> +({{ $currency.format(question.options.find(x => x.id == question.answer).price, { code: $parseCurrency(registrationForm.paymentInfo.currency) }) }}) </span>
    </template>
    <template v-else-if="question.type == 16 && !question.allowMultipleSelections && question.options.find(x => x.id == question.answer)">
      <span>
        {{ question.options.find(x => x.id == question.answer).title }}
      </span>
      <span class="price" v-if="question.options.find(x => x.id == question.answer).price > 0"> +({{ $currency.format(question.options.find(x => x.id == question.answer).price, { code: $parseCurrency(registrationForm.paymentInfo.currency) }) }}) </span>
    </template>
    <template v-else-if="question.type == 100 || (question.type == 16 && question.allowMultipleSelections)">
      <el-tag v-for="(option, optionIndex) in question.answers" :key="question.type == 16 ? 'multi-dropdown-choice-' + optionIndex : 'multipli-choice-' + optionIndex">
        <span>
          {{ question.options.find(x => x.id == option).title }}
        </span>
        <span class="price" v-if="question.options.find(x => x.id == option).price > 0"> +({{ $currency.format(question.options.find(x => x.id == option).price, { code: $parseCurrency(registrationForm.paymentInfo.currency) }) }}) </span>
      </el-tag>
    </template>
    <template v-else-if="question.type == 200">
      <el-rate :value="parseInt(question.answer)" disabled text-color="#ff9900"> </el-rate>
    </template>
    <template v-else-if="question.type == 201">
      <el-rate :value="parseInt(question.answer)" disabled :icon-classes="['icon-sad', 'icon-neutral', 'icon-smile', 'icon-grin']" disabled-void-icon-class="icon-smile" void-icon-class="icon-smile" :colors="['#99A9BF', '#F7BA2A', '#FF9900']"></el-rate>
    </template>
    <template v-else-if="question.type == 202">
      <el-slider :value="parseInt(question.answer)" :disabled="true" input-size="mini"> </el-slider>
    </template>
    <template v-else-if="question.type == 104">
      <div class="answer">
        <CoolLightBox :items="question.answers" :index="imageIndex" @close="imageIndex = null">
          <template slot="close">
            <i class="fas fa-times"></i>
          </template>
        </CoolLightBox>
        <div class="answers-files">
          <div class="answers-files-img" v-for="(file, index) in question.answers" @click="imageIndex = index" :key="index + '-question-file-' + question.id">
            <img :src="file" v-if="get_url_extension(file)" width="200px" />
            <div class="answers-icon-box" v-else>
              <i class="fas fa-play"></i>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-else-if="question.type == 32">
      <div class="answer">
        <CoolLightBox :items="[question.answer]" :index="imageIndex" @close="imageIndex = null">
          <template slot="close">
            <i class="fas fa-times"></i>
          </template>
        </CoolLightBox>
        <div class="answers-files">
          <div class="answers-files-img" @click="imageIndex = 0" :key="'one-image-' + question.id">
            <img :src="question.answer" v-if="get_url_extension(question.answer)" width="200px" />
            <div class="answers-icon-box" v-else>
              <i class="fas fa-play"></i>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-else-if="question.type == 101">
      {{ $moment(question.answer).format(dateFormatEvent($store.state.event.event.dateFormat)) }}
    </template>
    <template v-else-if="question.type == 102">
      {{ $moment(question.answer).format(timeFormatEvent($store.state.event.event.timeFormat)) }}
    </template>
    <template v-else>{{ question.answer }}</template>
  </div>
</template>

<script>
export default {
  props: ["question", "registrationForm"],
  data() {
    return {
      imageIndex: null
    };
  },
  methods: {
    get_url_extension(url) {
      var ImagesExtenstions = ["png", "jpg", "jpeg", "bmp", "gif", "tif", "tiff", "eps"];
      var splitting = url
        .split(/[#?]/)[0]
        .split(".")
        .pop()
        .trim();
      if (ImagesExtenstions.some(x => x == splitting)) {
        return true;
      } else {
        return false;
      }
    }
  }
};
</script>

<style scoped lang="less">
.answer {
  .price {
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/register-form/Inputs/QuestionItem.vue